var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ranking-list',{attrs:{"title":"Top analysts","items":_vm.items,"active-id":_vm.data.id,"processed":true,"settings":{
    title: 'Top analysts',
    path: 'analysts',
    colWidth: 12,
    cols: ['name', 'views'],

    type: 'infinity-rank',
  },"client-width":_vm.clientWidth}})}
var staticRenderFns = []

export { render, staticRenderFns }